import { BindAll } from 'lodash-decorators'

import { observable } from 'mobx'

import { show, update, DeliveryUpdateParams, Delivery } from 'vendor/server/public/deliveries'

@BindAll()
export default class DeliveryStore {
  @observable selectedDelivery: Delivery | null = null

  async selectDelivery(id: string | null): Promise<void> {
    if (!id) {
      this.selectedDelivery = null
      return
    }
    this.selectedDelivery = (await show(id)).data
  }

  async updateDelivery(delivery: DeliveryUpdateParams): Promise<Delivery> {
    return (await update(delivery)).data['delivery']
  }
}
